export const userLabels = [
  {
    'created_at': 1630574818,
    'user_uuid': 'ec4de62a-cecc-40e8-b066-8a7297633d5c',
    'uuid': 'ec4de62a-cecc-40e8-b066-8a7297633d5b',
    'patient_uuid': 'ec4de62a-cecc-40e8-b066-8a7297633d5c',
    'label': 'yellow'
  },
  {
    'created_at': 1630574818,
    'user_uuid': 'ec4de62a-cecc-40e8-b066-8a7297633d5c',
    'uuid': 'ec4de62a-cecc-40e8-b066-8a7297633d5b',
    'patient_uuid': '2676361a-3113-4eb7-8fda-0231f8f5ca23',
    'label': 'green'
  }
]



// WEBPACK FOOTER //
// ./src/_helpers/backend-data/user-label.js